<template>
    <defaultSec :title="'< 返回'" :returnState="true">
        <div>
            <el-form :model="form" label-width="120px">
                <el-form-item label="属性名称" prop="propertyName" :required="true">
                    <el-input v-model="form.propertyName" placeholder="属性名称"></el-input>
                </el-form-item>
                <el-form-item label="sql表达式" prop="propertyField" :required="true">
                    <el-input v-model="form.propertyField" placeholder="sql表达式"></el-input>
                </el-form-item>
                <el-form-item label="属性分类" prop="propertyClass" :required="true">
                    <el-select v-model="form.propertyClass" filterable clearable placeholder="属性分类">
                        <el-option v-for="item in propertyClassList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="示例" prop="propertyDemo" :required="true">
                    <el-input v-model="form.propertyDemo" placeholder="属性表字段"></el-input>
                </el-form-item>
                <el-form-item label="排序" :required="true">
                    <el-input-number v-model="form.sort" :min="1" :max="1000" placeholder=""></el-input-number>
                </el-form-item>
                <el-form-item label="属性id" prop="eventId" v-show="false">
                    <el-input v-model="form.eventId" placeholder="请输入属性id"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save" size="mini" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    export default {
        data() {
            return {
                formParam: {
                    pageSize: 15,
                    currentPage: 1,
                    eventName:'',
                    eventType:'',
                    status:'',
                    eventTableName:'',
                },
                propertyTypeList:[],
                propertyClassList:[],
                properytDataTypeList:[],
                form: {
                    propertyId: '',
                    propertyName:'',
                    propertyField:'',
                    propertyClass:1,
                    properytDataType:'String',
                    propertyType:2,
                    eventRemark:'',
                    sort:1
                },
                total: 0
            }
        },
        components: {
            defaultSec, tablePagination
        },
        mounted(){
            if(this.$route.params.propertyId || 0>0){
                this.getDetail()
            }
            this.initPropertyTypeList()
            this.initPropertyClassList()
            this.initPropertyDataTypeList()
        },
        methods: {
            getDetail() {
                this.$apiGet('lechun-cms/scrmproperty/getProperty', {propertyId: this.$route.params.propertyId}).then(res => {
                    this.form = res
                })
            },
            initPropertyTypeList(){
                this.$apiGet('lechun-cms/scrmproperty/getPropertyTypeList', {}).then(res => {
                    console.log(res)
                    this.propertyTypeList=res
                })
            },
            initPropertyClassList(){
                this.$apiGet('lechun-cms/scrmproperty/getPropertyClassList', {}).then(res => {
                    console.log(res)
                    this.propertyClassList=res
                })
            },
            initPropertyDataTypeList(){
                this.$apiGet('lechun-cms/scrmproperty/getPropertyDataTypeList', {}).then(res => {
                    console.log(res)
                    this.properytDataTypeList=res
                })
            },
            save(){
                if(this.form.propertyName==''){
                    this.$message({
                        showClose: true,
                        message: '属性名必填',
                        type: 'error'
                    });
                    return;
                }
                if(this.form.propertyField==''){
                    this.$message({
                        showClose: true,
                        message: '属性字段必填',
                        type: 'error'
                    });
                    return;
                }
                if(this.form.propertyType==''){
                    this.$message({
                        showClose: true,
                        message: '类型必选',
                        type: 'error'
                    });
                    return;
                }
                if(this.form.propertyClass==''){
                    this.$message({
                        showClose: true,
                        message: '分类必选',
                        type: 'error'
                    });
                    return;
                }
                this.$apiGet('lechun-cms/scrmproperty/saveProperty', this.form).then(res => {
                    console.log(res)
                    if(res.status==200){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.initList()
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteProerty(propertyId){
                this.$confirm('删除后不可撤销，确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$apiGet('lechun-cms/scrmproperty/deleteProperty', {propertyId:propertyId}).then(res => {
                        console.log(res)
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>


<style scoped>
    .expand-title {
        width: 70px;
        color: #444548;
        line-height: 30px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }

    .expand-flex {
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }
</style>